import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondQueryKey } from "../bond.keys";
import { AdminSuretyBond } from "./types";

export const useAdminFetchBond = (id: string, enabled: boolean = true) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondQueryKey(id),
		queryFn: async () => await get<AdminSuretyBond>(`/v2/admin/surety/bonds/${id}`),
		retry: false,
		enabled,
	});

	return { bond: data, bondError: error, bondLoading: isLoading };
};
